import React, { useState, useEffect } from "react";

const dayString = () => new Date().toLocaleDateString("en-US", { weekday: "long" });

const Day = () => {
  const [day, setDay] = useState(dayString());

  // Re-check periodically so the day name rolls over at midnight on an
  // always-on display without needing a refresh.
  useEffect(() => {
    const timer = setInterval(() => setDay(dayString()), 30 * 1000);
    return () => clearInterval(timer);
  }, []);

  return (
      <div className="day"> {day} </div>
  );
};

export default Day;
